import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { ReactComponent as Hamburger } from '../assets/hamburger.svg';
import React, { useState } from "react";
import avatar from "../assets/avatar.webp";

export default function Navbar() {
  const [showNav, setShowNav] = useState(false);

  return (
    <nav className="nav">
      <Link to="/" className="avatar-wrapper">
        <div 
          className="avatar" 
          style={{
            backgroundImage: `url(${avatar})`,
            backgroundSize: "cover",
            backgroundPosition: "center"}}
        ></div>
      </Link>
      <ul className={`${showNav ? "classNames active" : "classNames"}`}>
        <CustomLink to="/" className="bodycopy" onClick={() => {setShowNav(!showNav)}}>Home</CustomLink>
        <CustomLink to="/film" className="bodycopy" onClick={() => {setShowNav(!showNav)}}>Film</CustomLink>
        <CustomLink to="/foto" className="bodycopy" onClick={() => {setShowNav(!showNav)}}>Foto</CustomLink>
        <CustomLink to="/kontakt" className="bodycopy thumb-link" onClick={() => {setShowNav(!showNav)}}>
          Kontakt
        </CustomLink>
      </ul>
      <Link className="back-button-wrapper">
        <Hamburger className="menu-icon" fill="#ece3dd" onClick={() => {
          setShowNav(!showNav);
        }} />
      </Link>
    </nav>
  );
}

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <li className={isActive ? "active" : ""}>
      <Link 
        to={to}
        {...props}
        aria-current={isActive ? 'page' : undefined}
        aria-label={`Zur Seite ${typeof children === "string" ? children : to.replace("/", "")}`}
        title={`Zur Seite ${typeof children === "string" ? children : to.replace("/", "")}`}
      >
        {/* Apply active class to children if it's an element (like #thumb) */}
        {React.isValidElement(children)
          ? React.cloneElement(children, { className: `${children.props.className || ""} ${isActive ? "active" : ""}` })
          : children}
      </Link>
    </li>
  );
}
